// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { PharmacyGroupsState } from '../_reducers/pharmacy-group.reducers';
import { PharmacyGroup } from '../_models/pharmacy-group.model';

export const selectPharmacyGroupsState =
  createFeatureSelector<PharmacyGroupsState>('pharmacyGroups');

export const selectPharmacyGroupById = (pharmacyGroupId: number) =>
  createSelector(
    selectPharmacyGroupsState,
    (pharmacyGroupsState) => pharmacyGroupsState.entities[pharmacyGroupId],
  );

export const selectPharmacyGroupsPageLoading = createSelector(
  selectPharmacyGroupsState,
  (pharmacyGroupsState) => {
    return pharmacyGroupsState.listLoading;
  },
);

export const selectPharmacyGroupsActionLoading = createSelector(
  selectPharmacyGroupsState,
  (pharmacyGroupsState) => pharmacyGroupsState.actionsloading,
);

export const selectLastCreatedPharmacyGroupId = createSelector(
  selectPharmacyGroupsState,
  (pharmacyGroupsState) => pharmacyGroupsState.lastCreatedPharmacyGroupId,
);

export const selectPharmacyGroupsPageLastQuery = createSelector(
  selectPharmacyGroupsState,
  (pharmacyGroupsState) => pharmacyGroupsState.lastQuery,
);
export const selectPharmacyGroupError = createSelector(
  selectPharmacyGroupsState,
  (pharmacyGroupsState) => pharmacyGroupsState.error,
);
export const selectPharmacyGroupLatestSuccessfullAction = createSelector(
  selectPharmacyGroupsState,
  (pharmacyGroupsState) => pharmacyGroupsState.latestSuccessfullAction,
);
export const selectPharmacyGroupsInStore = createSelector(
  selectPharmacyGroupsState,
  (pharmacyGroupsState) => {
    const items = (pharmacyGroupsState.ids as number[])
      .map((id) => pharmacyGroupsState.entities[id])
      .filter((item): item is PharmacyGroup => item !== undefined);
    return new QueryResultsModel(items, pharmacyGroupsState.totalCount);
  },
);

export const selectPharmacyGroupsShowInitWaitingMessage = createSelector(
  selectPharmacyGroupsState,
  (pharmacyGroupsState) => pharmacyGroupsState.showInitWaitingMessage,
);

export const selectHasPharmacyGroupsInStore = createSelector(
  selectPharmacyGroupsState,
  (queryResult) => {
    if (!queryResult.totalCount) {
      return false;
    }

    return true;
  },
);
